import React, { useEffect } from 'react';
import { Button, historyHandler, Modal } from 'jd-library';
import styles from './commonStyle.scss';

const NoDescription = props => {
    return (
            <Modal
                settings={{
                    modalId: 'ai-modals',
                    variant: 'action',
                    class: styles["ai-modals"],
                }}
                backdropStatic
                onHidden={props.onHidden}
            >
                <Modal.CloseIcon />
                <Modal.Header className={styles['modal-heading']}>Generate a Description</Modal.Header>
                <Modal.Body className={styles['modal-body']}>
                    Looks like you have not added a description for this {props.prodServLabel.toLowerCase()}
                    <br />
                    <br />
                    Click the button below to let AI write a description
                </Modal.Body>
                <div className={styles['btn-holder']}>
                    <Button
                        onClick={() => {
                            props.recordImpression('genDescBtn');
                            historyHandler.closeCurrent();
                            setTimeout(() => {
                                let descEle = document.querySelector(".wyswig-div [contenteditable]");
                                descEle.scrollIntoView({behavior: "smooth", block: "center" });
                                descEle.focus();
                                props.generateDescription()
                            }, 500);
                        }}
                    >
                        Generate AI Description                        
                    </Button>
                    <Button
                        variant={'default'}
                        onClick={() => {
                            historyHandler.closeCurrent();
                            setTimeout(() => {
                                props.onSave();
                            }, 500);
                        }}
                    >
                        Save Without Description
                    </Button>
                </div>
            </Modal>
    )
}

export default NoDescription;